import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { getPublicSettings } from "../services/adminApi";

const ROLES = [
  {
    key: "driver",
    path: "/enrollme/driver/login",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      </svg>
    ),
    label: "Driver",
    sub: "Access your earnings, documents,\nand enrollment progress.",
    accent: "#3b82f6",
    accentBg: "rgba(59,130,246,0.12)",
    accentBorder: "rgba(59,130,246,0.3)",
  },
  {
    key: "admin",
    path: "/enrollme/admin/login",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l2.09 6.26L20 9.27l-5 4.87 1.18 6.88L12 17.77l-4.18 3.25L9 14.14 4 9.27l5.91-1.01L12 2z" />
      </svg>
    ),
    label: "Admin",
    sub: "Manage drivers, compliance,\nand company operations.",
    accent: "#a78bfa",
    accentBg: "rgba(167,139,250,0.12)",
    accentBorder: "rgba(167,139,250,0.3)",
  },
];

export default function Landing() {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  useEffect(() => {
    getPublicSettings().then((d) => setCompanyName(d.companyName || d.companyTradeName || ""));
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-5 py-14"
      style={{ background: "linear-gradient(160deg, #0d1b3e 0%, #0a0f2c 50%, #060b1f 100%)" }}
    >
      {/* Glow */}
      <div style={{ position: "fixed", inset: 0, pointerEvents: "none", background: "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(59,130,246,0.12) 0%, transparent 60%)" }} />

      <div className="relative z-10 w-full max-w-sm">
        {/* Logo + title */}
        <div className="text-center mb-10">
          <img
            src={logo}
            alt="EnrollMe"
            className="h-16 w-16 object-contain rounded-2xl mx-auto mb-5"
            style={{ boxShadow: "0 4px 28px rgba(0,0,0,0.5)" }}
          />
          <p className="text-xs font-semibold text-blue-400 uppercase tracking-widest mb-1">EnrollMe</p>
          <h1 className="text-2xl font-bold text-white mb-1" style={{ letterSpacing: "-0.02em" }}>
            {companyName}
          </h1>
          <p className="text-slate-400 text-sm">Who's signing in today?</p>
        </div>

        {/* Role cards */}
        <div className="space-y-3">
          {ROLES.map(({ key, path, icon, label, sub, accent, accentBg, accentBorder }) => (
            <button
              key={key}
              onClick={() => navigate(path)}
              className="w-full text-left rounded-2xl px-5 py-5 flex items-center gap-4 transition-all duration-200 group"
              style={{
                background: "rgba(15,23,42,0.7)",
                border: `1px solid rgba(148,163,184,0.14)`,
                backdropFilter: "blur(12px)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = accentBorder;
                e.currentTarget.style.background = `rgba(15,23,42,0.85)`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(148,163,184,0.14)";
                e.currentTarget.style.background = "rgba(15,23,42,0.7)";
              }}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-200"
                style={{ background: accentBg, border: `1px solid ${accentBorder}`, color: accent }}
              >
                <div style={{ width: 24, height: 24 }}>{icon}</div>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <p className="text-base font-semibold text-white mb-0.5">{label} Portal</p>
                <p className="text-xs text-slate-400 leading-snug whitespace-pre-line">{sub}</p>
              </div>

              {/* Arrow */}
              <svg
                className="w-4 h-4 text-slate-500 group-hover:text-slate-300 transition-colors flex-shrink-0"
                fill="none" stroke="currentColor" viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          ))}
        </div>

        <p className="text-center text-xs text-slate-600 mt-10">
          © {new Date().getFullYear()} Old Alex Hub, LLC · All rights reserved
        </p>
      </div>
    </div>
  );
}
